export const defaultLocales = ['en-US'];
export const defaultTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';

export const secondsInMinute = 60;
export const minutesInHour = 60;
export const halfAnHourInMinutes = 30;
export const hoursInDay = 24;
export const milisecondsInSecond = 1000;
export const daysInWeek = 7;
export const millisecondsInDay = hoursInDay * minutesInHour * secondsInMinute * milisecondsInSecond;
